<template>
  <Index/>
</template>

<script>
  import Index from '@/components/admin/maestro/scraping_service/Index'

  export default {
    components: { Index },
    name: 'ScrapingService',
  }
</script>

<style scoped>
</style>